import React from 'react'
import styled from 'styled-components';
import { Button } from '@material-ui/core'
import { auth, provider } from '../firebase';


function Login() {
    const signin = e =>{
        e.preventDefault();
        auth.signInWithPopup(provider).catch((error)=>
        alert(error.message));

    }
    return (
        <LoginContainer>
            <LoginInnerContainer>
                <img src="https://cdn.dribbble.com/users/1238764/screenshots/5864612/slack-animation.gif" alt=""
                />

                <h1>
                    Sign in to Slack
                </h1>
                <p>
                soal.slack.com
                </p>

                <Button 
                    onClick={signin}
                >Sign in With Google</Button>
            </LoginInnerContainer>
        </LoginContainer>
    )
}

export default Login;

const LoginContainer = styled.div`
    background-color:#f8f8f8;
    height:100vh;
    display:grid;
    place-items:center;

`;

const LoginInnerContainer = styled.div`
    padding:100px;
    text-align:center;
    background-color:white;
    border-radius:50px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
 >img{
     object-fit:contain;
     height:200px;
     margin-bottom:80px;
    }

 >button{
     margin-top:50px;
     text-transform:inherit;
     background-color:#0a8d48;
     color:white;
 }

`;